import {Component, OnInit} from '@angular/core';
import {BenchmarkService} from './benchmarks.service';
import {LoginService} from '../../../services/login.service';
import {ApiService} from '../../../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-benchmarks',
  templateUrl: 'benchmarks.component.html',
  styleUrls: ['./benchmarks.component.css']
})
export class BenchmarksComponent implements OnInit {

  ruid: string;
  isloggedIn = false;
  isLicense: string;

  constructor(private benchmarkService: BenchmarkService,
              private loginService: LoginService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private notifications: NotificationsService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        if (this.ruid === 'demo') {
          this.reportsData();
        } else {
          this.loginService.isLoggedIn()
            .subscribe((currentUser) => {
                this.isloggedIn = currentUser.isLoggedIn;
                if (this.isloggedIn) {
                this.apiService.getSummary(this.ruid)
                  .subscribe((res) => {
                    this.isLicense = res.isLicense;
                    if (!res.isLicense) {
                      this.reportsData();
                    } else {
                      this.notifications.warn(this.translate.instant('reports.benchmark.license'), this.translate.instant('reports.benchmark.ruidOfLicense'));
                    }
                  }, (error) => {
                    this.notifications.error(this.translate.instant('common.error'), this.translate.instant('reports.benchmark.invalidRuid'));
                  });
              }
            });
        }
      }
    });
  }

  reportsData() {
    this.benchmarkService.setBenchmarks(this.ruid).subscribe((res) => {
      this.router.navigate(['reports/myreports/benchmarks/average-session'], {queryParams: {ruid: this.ruid}});
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/benchmarks/benchmarks.component.ts